import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { unpack_validation, } from 'webui/Z3KConfigParser/validation/types';
import { MaterialDropdown } from 'console/shared/components/fields';
import { BoilerControlType } from '../type';
import { SettingCard } from 'console/device-settings/z3k/components/material-utils/settings-card/card';
import { removeNulls } from 'utils';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
const strip_name = (name) => name.substr(0, 10);
export const BoilerRow = memo(function BoilerRow(props) {
    const { number, settings, validation, onChange } = props;
    const onChangeName = useCallback((value) => onChange({ name: strip_name(value) }), [onChange, strip_name]);
    const onChangeType = useCallback((value) => onChange({ control_type: value }), [onChange]);
    const boiler_control_type_options = useMemo(() => removeNulls([
        { text: 'Отключен', value: BoilerControlType.OFF },
        { text: 'Реле', value: BoilerControlType.RELAY },
        settings.has_adapter_on_slot
            ? {
                text: 'Цифровая шина',
                value: BoilerControlType.DIGITAL,
            }
            : null,
        settings.show_unknown_option
            ? {
                text: 'Неизвестный',
                value: BoilerControlType.UNKNOWN,
            }
            : null,
    ]), [settings.has_adapter_on_slot, settings.show_unknown_option]);
    const type_field = useCallback((input_props) => (_jsx(MaterialDropdown, { options: boiler_control_type_options, ...input_props })), [boiler_control_type_options]);
    return (_jsxs(SettingCard, { title: `Котёл №${number}`, container_props: {
            gridTemplateColumns: 'repeat(auto-fill, minmax(235px, 1fr))',
        }, children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", validation_result: unpack_validation(validation, 'name'), validation_warnings_result: null, value: settings.name, onChange: onChangeName, field: TextInputWrapper, help_id: null }), _jsx(Control, { label: "\u0422\u0438\u043F", validation_result: unpack_validation(validation, 'control_type'), validation_warnings_result: null, value: settings.control_type, onChange: onChangeType, field: type_field, help_id: null })] }));
});
